import { create, tsx } from '@dojo/framework/core/vdom';

import * as css from './NewsLetter.m.css';
import Text from '../../widgets/Text';

const factory = create();

export const NewsLetter = factory(function NewsLetter() {
	return (
		<virtual>
			<div classes={[css.copy]}>
				<Text type="callout-head" responsive="section" align="center">
					Receive Our Latest Insights!
				</Text>
				<Text type="large-body" responsive="body" align="center">
					Sign up to receive our latest articles on JavaScript, TypeScript, and all things
					software development!
				</Text>
			</div>
			<iframe
				classes={[css.iframe]}
				title="Newsletter"
				id="Newsletter"
				name="Newsletter"
				src="newsletter/form"
				data-min-height="78"
			/>
		</virtual>
	);
});

export default NewsLetter;
